import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { cn } from '@/lib/utils';

interface AccountSwitcherProps {
  isCollapsed: boolean;
  accounts: {
    label: string;
    email: string;
    grantId: string;
    icon: React.ReactNode;
  }[];
  onChange?: (data: { email: string; grantId: string }) => void;
  value?: string;
}

export function AccountSwitcher({
  isCollapsed,
  accounts,
  onChange,
  value,
}: AccountSwitcherProps) {
  const handleChange = (grantId: string) => {
    const selected = accounts.find((account) => account.grantId === grantId);
    if (selected) {
      onChange?.({ email: selected.email, grantId: selected.grantId });
    }
  };

  const currentAccount = accounts.find((account) => account.grantId === value);

  return (
    <Select value={value || ''} onValueChange={handleChange}>
      <SelectTrigger
        className={cn(
          'flex items-center gap-2 [&>span]:line-clamp-1 [&>span]:flex [&>span]:w-full [&>span]:items-center [&>span]:gap-1 [&>span]:truncate [&_svg]:h-4 [&_svg]:w-4 [&_svg]:shrink-0',
          isCollapsed
          && 'flex h-9 w-9 shrink-0 items-center justify-center p-0 [&>span]:w-auto [&>svg]:hidden',
        )}
        aria-label="Select account"
      >
        <SelectValue placeholder="Select an account">
          {currentAccount?.icon}
          <span className={cn('ml-2', isCollapsed && 'hidden')}>
            {currentAccount?.label}
          </span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {accounts.map((account) => (
          <SelectItem key={account.grantId} value={account.grantId}>
            <div className="flex items-center gap-3 [&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:text-foreground">
              {account.icon}
              {account.email}
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
